import { Link } from 'react-router-dom';

import './GlobalFooter.css';

const GlobalFooter = () => (
  <footer className="globalFooter">
    <div className="globalFooterInner">
      <span>© ASiJoLab</span>
      <nav aria-label="Legal and contact links">
        <Link to="/terms">Terms</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/cookies">Cookies</Link>
        <Link to="/contact">Contact</Link>
      </nav>
    </div>
  </footer>
);

export default GlobalFooter;
